export default {
  namespaced: true,
  state: {
    menusAreOpened: false,
  },
  getters: {
    menusAreOpened: state => state.menusAreOpened,
  },
  actions: {
    updateMenusAreOpened(context) {
      context.commit('UPDATE_MENU_ARE_OPENED');
    },
  },
  mutations: {
    UPDATE_MENU_ARE_OPENED(state) {
      state.menusAreOpened = !state.menusAreOpened;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ui/index.js